// extracted by mini-css-extract-plugin
module.exports = {"modal_background":"style_modal_background__1G7RU","modal":"style_modal__1f_rw","close":"style_close__3-gfP","notification":"style_notification__2acAR"};